/* eslint-disable react/jsx-no-duplicate-props */
import { Button, Col, Form, Row } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";
import Axios from "axios";
import { getUpdate, postCreate, PutUpdate } from "components/Data";
import InputClock from "components/inputs/InputClock";
import InputControl from "components/inputs/InputControl";
import InputControlAsync from "components/inputs/InputControlAsync";
import InputDate from "components/inputs/InputDate";
import InputNumber from "components/inputs/InputNumber";
import InputPricing from "components/inputs/InputPricing";
import InputControlMulti from "components/inputs/InputControlMulti";
import Switchrs from "components/inputs/Switchrs";
import Loader from "components/layout/Loader";
import toaster from "helper/toaster";
import DashboardContext from "Context";
import FormAddres from "./FormAddres";
import FormGroupoption from "./FormGroupoption";
import FormPreiod from "./FormPreiod";
import FormsetGroup from "./FormsetGroup";
import InputSuggestion from "./InputSuggestion";
import ModalAddCoustmer from "./ModalAddCoustmer";
import AmountPerHourInfo from "./AmountPerHourInfo";
import NumberFormat from "react-number-format";
import { Space } from "antd";

/**
 * این کامپوننت برای نمایش فرم ثبت سفارش است
 * در پروفایل مشتری نیرو و صفحه سفارشات استفاده شده است
 */
const FormOrder = ({ userprofile }) => {
  const {
    urlPatch,
    authentication,
    urldashboard,
    handelAdd,
    edit,
    handelloding,
    handelEdit,
    loding,
    handeldmicro,
    handelerrors,
    handelEditOrder,
  } = useContext(DashboardContext);

  const [dataFromGrpoup, setDataFromGrpoup] = useState({});

  const handeldatafromgroup = (data) => {
    setDataFromGrpoup(data);
    handleSetFormdata({ ...formdata, ...data });
  };

  const [preiod, setPreiod] = useState(false);

  const handlePreiod = (status) => setPreiod(status);

  const [, setAddressId] = useState();

  const handelDataAddress = (id) => {
    handleSetFormdata({ ...formdata, addressId: id });
    setAddressId(id);
  };

  const handelDataAddressPart = (id) => {
    handleSetFormdata({ ...formdata, userBussinessGroupId: id });
  };

  const [datapreiod, setDatapreiod] = useState({});

  const handlePreiodForm = (data) => {
    setDatapreiod(data);
    handleSetFormdata({ ...formdata, ...data });
  };

  const [dataFromGroupOption, setDataFromGroupOption] = useState([]);

  const handelGroupOption = (item) => {
    setDataFromGroupOption(item);
    handleSetFormdata({ ...formdata, orderOptions: item });
  };

  const [startDate, setStartDate] = useState("");

  const [startclock, setStartclock] = useState();

  //logic hocForm

  const [LoadingForm, setLoadingForm] = useState(false);

  const [dataUpdate, setDataUpdate] = useState({});

  const [formdata, setFormdata] = useState({
    isActive: true,
    userId: userprofile ? userprofile : "",
  });

  const handleSetFormdata = (object) => setFormdata(object);

  const handelLoadingform = (item) => setLoadingForm(item);

  const handelSend = async () => {
    await postCreate(
      `${urldashboard}/Order/create`,
      authentication,
      formdata,
      handelLoadingform,
      handelAdd,
      handeldmicro,
      handelerrors
    );
  };

  const handelUpdataFrom = async () => {
    await PutUpdate(
      `${urldashboard}/Order/update`,
      formdata,
      authentication,
      handelLoadingform,
      handelEdit,
      handelAdd,
      handeldmicro,
      handelerrors,
      userprofile,
      handelEditOrder
    );
  };

  const dataFeching = async () => {
    await getUpdate(
      `${urldashboard}/Order/update/${edit}`,
      authentication,
      handelloding,
      handelAdd,
      handelEdit,
      handelDataUpdate,
      handeldmicro,
      handelerrors
    );
  };

  const handelDataUpdate = (data) => {
    setDataFromGroupOption(data.orderOptions);
    setStartDate(
      data.hasOwnProperty("startWork") ? data.startWork.split("T")[0] : ""
    );
    setStartclock(
      data.hasOwnProperty("startWork") ? data.startWork.split("T")[1] : ""
    );
    setAddressId(data.addressId);

    setEditMode(true);

    setDataUpdate(data);
    setFormdata(data);
  };

  const [mobileUser, setMobileUser] = useState();

  const [idUserCreate, setIdUserCreate] = useState();

  const setUserId = (data) => {
    handleSetFormdata({ ...formdata, userId: data });
    setIdUserCreate(data);
  };

  const setUsemobileCreate = (data) => setMobileUser(data);

  useEffect(() => {
    if (edit) {
      dataFeching();
    } else {
      handelloding(false);
    }
    return () => {};
  }, [idUserCreate]);

  const [clear, setClear] = useState(false);

  const handelValue = (name, value) => {
    switch (name) {
      case "userId":
        handleSetFormdata({ ...formdata, userId: value });
        break;
      case "categoryId":
        handleSetFormdata({ ...formdata, categoryId: value });
        break;
      case "groupId":
        handleSetFormdata({ ...formdata, groupId: value });
        break;
      case "workerId":
        handleSetFormdata({ ...formdata, workerId: value });
        break;
      case "instructionId":
        handleSetFormdata({ ...formdata, instructionId: value });
        break;
      case "paymentType":
        handleSetFormdata({ ...formdata, paymentType: value });
        break;
      case "startWork":
        setStartDate(value);
        handleSetFormdata({
          ...formdata,
          startWork: `${value}T${startclock ? startclock : "00:00"}`,
        });
        break;
      case "startClock":
        setStartclock(value);
        handleSetFormdata({ ...formdata, startWork: `${startDate}T${value}` });
        break;
      case "periodTime":
        handleSetFormdata({ ...formdata, periodTime: value });
        break;
      case "confirmByCustomer":
        handleSetFormdata({ ...formdata, confirmByCustomer: value });
        break;
      case "isActiveFormOrder":
        handleSetFormdata({ ...formdata, isActive: value });
        break;
      case "ignoreFormOrder":
        handleSetFormdata({ ...formdata, ignore: value });
        break;
      case "description":
        handleSetFormdata({ ...formdata, description: value });
        break;
      case "workerDescription":
        handleSetFormdata({ ...formdata, workerDescription: value });
        break;
      case "customerDescription":
        handleSetFormdata({ ...formdata, customerDescription: value });
        break;
      case "isFavorite":
        handleSetFormdata({ ...formdata, isFavorite: value });
        break;
      case "orderType":
        handleSetFormdata({ ...formdata, orderType: value });
        break;
      case "customAmountType":
        handleSetFormdata({ ...formdata, customAmountType: value });
        break;
      case "commission":
        handleSetFormdata({ ...formdata, commission: parseInt(value) });
        break;
      case "customGroupDiscount":
        handleSetFormdata({
          ...formdata,
          customGroupDiscount:
            value !== 0 && value !== undefined && value !== null && value !== ""
              ? value
              : 0,
        });
        break;
      case "hasNoGroupDiscount":
        handleSetFormdata({ ...formdata, hasNoGroupDiscount: value });
        break;
      case "isRepeatFormOrder":
        handleSetFormdata({ ...formdata, isRepeat: value });
        break;
      case "commissionAmount":
        handleSetFormdata({ ...formdata, commissionAmount: value });
        break;
      case "additionalAmount":
        handleSetFormdata({ ...formdata, additionalAmount: value });
        break;
      case "orderFacilityIds":
        handleSetFormdata({ ...formdata, orderFacilityIds: value });
        break;
      case "isSendCustomerNotification":
        handleSetFormdata({ ...formdata, isSendCustomerNotification: value });
        break;
      case "isSendWorkerNotification":
        handleSetFormdata({ ...formdata, isSendWorkerNotification: value });
        break;
      case "discountCouponId":
        handleSetFormdata({
          ...formdata,
          discountCouponId: value,
        });
        setClear(true);
        break;
      case "hasAlternative":
        handleSetFormdata({ ...formdata, hasAlternative: value });
        break;
      case "presenterId":
        handleSetFormdata({ ...formdata, presenterId: value });
        break;
      case "specialOrderMissionDetailId":
        handleSetFormdata({ ...formdata, specialOrderMissionDetailId: value });
        break;
      case "isAutoFindWorker":
        handleSetFormdata({ ...formdata, isAutoFindWorker: value });
        break;
      case "workersCanWorkVoluntarily":
        handleSetFormdata({ ...formdata, workersCanWorkVoluntarily: value });
        break;
      case "volunteersCapacity":
        handleSetFormdata({ ...formdata, volunteersCapacity: value });
        break;
      default:
        break;
    }
  };

  const handelSubmit = (event) => {
    event.preventDefault();
    handelLoadingform(true);

    if (!formdata.userId && formdata.orderType !== 5) {
      toaster.error("لطفا نام مشتری را وارد کنید");
      handelLoadingform(false);
    } else if (!formdata.categoryId) {
      toaster.error("لطفا دسته‌بندی را وارد کنید");
      handelLoadingform(false);
    } else if (!formdata.groupId && formdata.orderType !== 5) {
      toaster.error("لطفا گروه را وارد کنید");
      handelLoadingform(false);
    } else if (!startDate && formdata.orderType !== 5) {
      toaster.error("لطفا تاریخ شروع را وارد کنید");
      handelLoadingform(false);
    } else if (!startclock && formdata.orderType !== 5) {
      toaster.error("لطفا ساعت روز شروع را وارد کنید");
      handelLoadingform(false);
    } else if (!formdata.startWork && formdata.orderType !== 5) {
      toaster.error("لطفا تاریخ و روز شروع را وارد کنید");
      handelLoadingform(false);
    } else if (!formdata.addressId && formdata.orderType !== 5) {
      toaster.error("لطفا یک آدرس را انتخاب کنید");
      handelLoadingform(false);
    } else if (!formdata.paymentType && formdata.orderType !== 5) {
      toaster.error("لطفا نوع پرداخت را انتخاب کنید");
      handelLoadingform(false);
    } else if (formdata.orderType === null && formdata.orderType !== 5) {
      toaster.error("لطفا نوع سفارش را انتخاب کنید");
      handelLoadingform(false);
    } else {
      dataUpdate?.userId ? handelUpdataFrom() : handelSend();
    }
  };

  // FormAddCoustumer
  const [showAddCustomer, setShowAddCustomer] = useState(false);

  const handleCloseCustomer = () => setShowAddCustomer(false);

  // getinvoice
  const [editMode, setEditMode] = useState(false);

  const [invoiceData, setInvoiceData] = useState({});

  const handleGetInvoice = async () => {
    const dataForm = {
      customAmountMaleWorker: formdata.customAmountMaleWorker,
      customAmountFemaleWorker: formdata.customAmountFemaleWorker,
      userId: formdata.userId,
      groupId: formdata.groupId,
      startWork: formdata.startWork,
      periodTime: formdata.periodTime,
      numberMaleWorker: formdata.numberMaleWorker,
      numberFemaleWorker: formdata.numberFemaleWorker,
      additionalAmount: formdata.additionalAmount,
      commission: formdata.commission,
      commissionAmount: formdata.commissionAmount,
      orderFacilityIds: formdata.orderFacilityIds,
      orderType: formdata.orderType,
      orderOptions: formdata.orderOptions,
      customGroupDiscount: formdata.customGroupDiscount,
      hasNoGroupDiscount: formdata.hasNoGroupDiscount,
      orderScheduleId: formdata.id,
    };

    handelLoadingform(true);
    try {
      const res = await Axios.post(
        `${urldashboard}/order/getinvoice`,
        JSON.stringify(dataForm),
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json; charset=utf-8 ",
          },
        }
      );
      const data = await res.data.data;
      handelLoadingform(false);
      setInvoiceData(data);
    } catch (error) {
      handelerrors(error);
      handelLoadingform(false);
    }
  };

  const handlePutDataAmountPerHourInfo = (data) => {
    formdata.customAmountFemaleWorker = data.femaleAmountPerHour;
    formdata.customAmountMaleWorker = data.maleAmountPerHour;
    handleSetFormdata({ ...formdata, ...data });
  };

  return (
    <>
      {loding ? (
        <Loader />
      ) : (
        <Form>
          <Form.Row>
            {dataUpdate?.userId ? null : userprofile ? null : (
              <Col>
                <InputControlAsync
                  url='/userManagement/searchdropdown'
                  label='نام مشتری'
                  name='userId'
                  idSelect={idUserCreate}
                  defaultValue={mobileUser}
                  handelValue={handelValue}
                />

                <Button onClick={() => setShowAddCustomer(true)}>
                  افزودن مشتری<i className='fa fa-plus fa-lg mr-1'></i>
                </Button>
              </Col>
            )}

            {dataUpdate?.userId &&
            dataUpdate.orderTypeName !== "ثبت موقت" ? null : (
              <Col>
                <Col>
                  <InputControl
                    url='/category/dropdown/0/0'
                    label='دسته بندی'
                    name='categoryId'
                    handelValue={handelValue}
                    defaultValue={dataUpdate.categoryId}
                  />
                </Col>
                <Col>
                  {formdata.categoryId ? (
                    <InputControl
                      url={`/group/groupdropdown/${formdata.categoryId}`}
                      label='گروه'
                      name='groupId'
                      handelValue={handelValue}
                      defaultValue={dataUpdate.groupId}
                    />
                  ) : null}
                </Col>
              </Col>
            )}
          </Form.Row>
          <Form.Row>
            <Col lg='4' md='4' sm='6'>
              <InputClock
                label='ساعت شروع'
                name='startClock'
                handelValue={handelValue}
                defaultValue={
                  dataUpdate.hasOwnProperty("startWork")
                    ? dataUpdate.startWork.split("T")[1]
                    : ""
                }
              />
            </Col>

            <Col lg='4' md='4' sm='6'>
              <InputDate
                label='تاریخ شروع'
                name='startWork'
                handelValue={handelValue}
                defaultValue={
                  dataUpdate.hasOwnProperty("startWork")
                    ? dataUpdate.startWork.split("T")[0]
                    : ""
                }
              />
            </Col>
            {formdata.groupId ? (
              <FormsetGroup
                idGroup={formdata.groupId}
                dataUpdate={{
                  numberFemaleWorker: dataUpdate.numberFemaleWorker,
                  numberMaleWorker: dataUpdate.numberMaleWorker,
                  periodTime: dataUpdate.periodTime,
                }}
                dataArry={dataFromGrpoup}
                handelData={handeldatafromgroup}
                handelpreiod={handlePreiod}
              />
            ) : null}

            {formdata.groupId && formdata.periodTime ? (
              <AmountPerHourInfo
                groupId={formdata.groupId}
                periodTime={formdata.periodTime}
                startWork={formdata.startWork}
                handelPutData={handlePutDataAmountPerHourInfo}
                setOffEditMode={(flag) => setEditMode(flag)}
                editMode={editMode}
                dataUpdate={{
                  customAmountFemaleWorker: dataUpdate.customAmountFemaleWorker,
                  customAmountMaleWorker: dataUpdate.customAmountMaleWorker,
                }}
              />
            ) : null}
          </Form.Row>

          {dataUpdate.oldOrderOptions ? (
            dataUpdate.oldOrderOptions.length > 0 ? (
              <Row
                className='mb-2 mt-2 p-3'
                style={{ backgroundColor: "#ffffff", borderRadius: "20px" }}
              >
                <Col
                  className='d-flex text-center align-baseline justify-content-center'
                  md='12'
                  sm='12'
                  lg='12'
                  xs='12'
                >
                  <h3>موارد که در سیستم قبلی انتخاب شده بوده است :</h3>
                </Col>
                {dataUpdate.oldOrderOptions.map((item, index) => (
                  <Col
                    className='d-flex justify-content-center align-baseline'
                    md='2'
                    lg='2'
                    sm='6'
                    xs='6'
                  >
                    {index + 1} - {item}
                  </Col>
                ))}
              </Row>
            ) : null
          ) : null}
          {formdata.hasOwnProperty("numberMaleWorker") ||
          formdata.hasOwnProperty("numberFemaleWorker") ? (
            <FormGroupoption
              datasend={{
                numberMaleWorker:
                  formdata.numberMaleWorker === undefined
                    ? 0
                    : formdata.numberMaleWorker,
                numberFemaleWorker:
                  formdata.numberFemaleWorker === undefined
                    ? 0
                    : formdata.numberFemaleWorker,
                groupId: formdata.groupId,
              }}
              dataFromGroupOption={dataFromGroupOption}
              handelGroupOption={handelGroupOption}
            />
          ) : null}
          {dataUpdate?.userId ? null : preiod ? (
            <FormPreiod
              datapreiod={datapreiod}
              handelPreiodForm={handlePreiodForm}
            />
          ) : null}

          <div className='mb-3'>
            {formdata.userId ? (
              <FormAddres
                id={formdata.userId}
                dataUpdate={formdata.addressId}
                handelDataAddress={handelDataAddress}
                handelDataAddressPart={handelDataAddressPart}
                isSelectedAddressPart={formdata.userBussinessGroupId}
              />
            ) : null}
          </div>
          {dataUpdate?.userId ? null : (
            <Form.Row className='mb-5' style={{ alignItems: "center" }}>
              <Col>
                {(formdata?.userId &&
                  formdata?.groupId &&
                  formdata?.startWork &&
                  formdata?.numberFemaleWorker) ||
                (formdata?.userId &&
                  formdata?.groupId &&
                  formdata?.startWork &&
                  formdata?.numberMaleWorker) ? (
                  <InputSuggestion
                    userId={formdata?.userId}
                    groupId={formdata?.groupId}
                    addressId={formdata?.addressId}
                    NumberFemaleWorker={formdata?.numberFemaleWorker}
                    NumberMaleWorker={formdata?.numberMaleWorker}
                    startWork={formdata?.startWork}
                    label='نام نیرو'
                    name='workerId'
                    handelValue={handelValue}
                    defaultValue={dataUpdate.workerId}
                  />
                ) : null}
              </Col>
              <Col>
                <Switchrs
                  label='آیا روز های کاری نیرو نادیده گرفته شود؟'
                  name='ignoreFormOrder'
                  handelValue={handelValue}
                  defaultValue={dataUpdate.ignore}
                />
              </Col>
              <Col>
                <Switchrs
                  label='آیا نیرو مورد علاقه است؟'
                  name='isFavorite'
                  handelValue={handelValue}
                  defaultValue={dataUpdate.isFavorite}
                />
              </Col>

              {formdata?.userId &&
              formdata?.groupId &&
              formdata?.startWork &&
              (formdata?.numberMaleWorker || formdata?.numberFemaleWorker) ? (
                <>
                  <Col>
                    <Switchrs
                      label='آیا نیرو جایگزین است؟'
                      name='hasAlternative'
                      handelValue={handelValue}
                      defaultValue={dataUpdate?.presenterId ? true : false}
                    />
                  </Col>
                  {formdata?.hasAlternative ? (
                    <Col>
                      <InputSuggestion
                        userId={formdata?.userId}
                        groupId={formdata?.groupId}
                        addressId={formdata?.addressId}
                        NumberFemaleWorker={formdata?.numberFemaleWorker}
                        NumberMaleWorker={formdata?.numberMaleWorker}
                        startWork={formdata?.startWork}
                        label='نیروی معرفی‌کننده'
                        name='presenterId'
                        handelValue={handelValue}
                        defaultValue={dataUpdate?.presenterId}
                      />
                    </Col>
                  ) : null}
                </>
              ) : null}
            </Form.Row>
          )}
          <Form.Row>
            {startDate && (formdata?.userId || dataUpdate?.userId) && (
              <Col>
                <InputControlMulti
                  url={
                    datapreiod?.endWork
                      ? `/orderFacility/orderFacilityDropdown?fromDate=${
                          startDate ?? null
                        }&toDate=${datapreiod?.endWork}`
                      : `/orderFacility/orderFacilityDropdown?fromDate=${
                          startDate ?? null
                        }`
                  }
                  disabled={!startDate}
                  label='امکانات سفارش'
                  name='orderFacilityIds'
                  handelValue={handelValue}
                  defaultValue={dataUpdate.orderFacilityIds}
                  dependency={{
                    startDate: startDate,
                    endDate: datapreiod?.endWork,
                  }}
                />
              </Col>
            )}

            {startDate && formdata?.groupId && formdata?.categoryId && (
              <Col>
                <InputControl
                  isPost
                  label='سفارش خاص'
                  name='specialOrderMissionDetailId'
                  handelValue={handelValue}
                  url='/specialOrderMission/getDetailDropdown'
                  defaultValue={dataUpdate.specialOrderMissionDetailId}
                  dependency={{
                    orderStartDate: startDate,
                    groupId: formdata?.groupId,
                    categoryId: formdata?.categoryId,
                  }}
                  command={{
                    orderStartDate:
                      formdata?.startWork ?? dataUpdate?.startWork,
                    groupId: formdata?.groupId ?? dataUpdate?.groupId,
                    categoryId: formdata?.categoryId ?? dataUpdate?.categoryId,
                    bussinessType: 0,
                  }}
                />
              </Col>
            )}

            <Col>
              <InputControl
                url='/instruction/dropdown'
                label='دستور عمل سفارش'
                name='instructionId'
                handelValue={handelValue}
                defaultValue={dataUpdate.instructionId}
              />
            </Col>

            <Col>
              <InputControl
                url='/common/paymenttypedropdown'
                label='نوع پرداخت'
                name='paymentType'
                handelValue={handelValue}
                defaultValue={dataUpdate.paymentType}
              />
            </Col>
            <Col>
              <InputControl
                url='/common/ordertypedropdown'
                label='نوع سفارش'
                name='orderType'
                handelValue={handelValue}
                defaultValue={dataUpdate.orderType}
              />
            </Col>
            <Col>
              {editMode && dataUpdate?.additionalAmount ? (
                <Space direction={"vertical"} style={{ width: "100%" }}>
                  <small> هزینه های اضافه (ريال)</small>
                  <NumberFormat
                    thousandSeparator={","}
                    autoComplete={"off"}
                    defaultValue={dataUpdate?.additionalAmount}
                    decimalSeparator={"-"}
                    dir='ltr'
                    style={{
                      height: "50px",
                      width: "100%",
                      border: "none !important",
                      marginBottom: "1.5rem",
                    }}
                    onChange={(e) => {
                      const value = parseInt(e.target.value.replace(/,/g, ""));
                      handelValue("additionalAmount", value);
                    }}
                  />
                </Space>
              ) : (
                <InputPricing
                  label='هزینه های اضافه'
                  name='additionalAmount'
                  handelValue={handelValue}
                  defaultValue={dataUpdate.additionalAmount}
                />
              )}
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <InputNumber
                label='درصد پورسانت کار ثابت'
                name='commission'
                handelValue={handelValue}
                defaultValue={dataUpdate.commission}
              />
            </Col>
            {dataUpdate?.userId ? null : (
              <Col>
                <InputPricing
                  label='مبلغ پورسانت کار پرستاری'
                  name='commissionAmount'
                  handelValue={handelValue}
                  defaultValue={dataUpdate.commissionAmount}
                />
              </Col>
            )}
            <Col>
              <InputPricing
                handelValue={handelValue}
                name='customGroupDiscount'
                label='مبلغ دلخواه تخفیف محصول'
                defaultValue={dataUpdate.customGroupDiscount}
              />
            </Col>
            {((startDate &&
              formdata?.userId &&
              formdata?.groupId &&
              formdata?.categoryId) ||
              dataUpdate?.discountCouponId) && (
              <Col>
                <InputControl
                  isPost
                  label='کد تخفیف'
                  name='discountCouponId'
                  handelValue={handelValue}
                  url='/discountCoupon/getDropdown'
                  defaultValue={dataUpdate.discountCouponId}
                  dependency={{
                    date: startDate,
                    userId: formdata?.userId,
                    groupId: formdata?.groupId,
                    categoryId: formdata?.categoryId,
                    defaultDiscountCouponId: dataUpdate?.discountCouponId,
                  }}
                  command={{
                    date: startDate ?? dataUpdate?.startWork,
                    userId: formdata?.userId ?? dataUpdate?.userId,
                    groupId: formdata?.groupId ?? dataUpdate?.groupId,
                    categoryId: formdata?.categoryId ?? dataUpdate?.categoryId,
                  }}
                />
              </Col>
            )}
            <Switchrs
              label='نمیخواهم تخفیف محصول اعمال شود'
              name='hasNoGroupDiscount'
              handelValue={handelValue}
              checke={formdata.hasNoGroupDiscount}
            />
          </Form.Row>
          <Form.Row
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "2rem",
              marginTop: "1rem",
            }}
          >
            <Col>
              <Switchrs
                label='جستجوی خودکار نیرو'
                name='isAutoFindWorker'
                handelValue={handelValue}
                checke={formdata?.isAutoFindWorker}
              />
            </Col>
            <Col>
              <Switchrs
                handelValue={handelValue}
                label='آیا نیروها میتوانند داوطلب شوند؟'
                checke={formdata?.workersCanWorkVoluntarily}
                name='workersCanWorkVoluntarily'
              />
            </Col>
            <Col>
              {formdata?.workersCanWorkVoluntarily && (
                <InputNumber
                  label='ظرفیت نفرات داوطلب'
                  name='volunteersCapacity'
                  handelValue={handelValue}
                  defaultValue={formdata?.volunteersCapacity}
                />
              )}
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <div className='form-group'>
                <label htmlFor='descriptionTextarea'>توضیحات مخصوص کاربر</label>
                <textarea
                  className='form-control'
                  id='descriptionTextarea'
                  rows='6'
                  defaultValue={dataUpdate ? dataUpdate.description : ""}
                  onChange={(e) => handelValue("description", e.target.value)}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <div className='form-group'>
                <label htmlFor='workerDescriptionTextarea'>
                  توضیحات قابل نمایش برای نیرو
                </label>
                <textarea
                  className='form-control'
                  id='workerDescriptionTextarea'
                  rows='6'
                  defaultValue={dataUpdate ? dataUpdate.workerDescription : ""}
                  onChange={(e) =>
                    handelValue("workerDescription", e.target.value)
                  }
                  style={{ borderWidth: "2px" }}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <div className='form-group'>
                <label htmlFor='customerDescriptionTextarea'>
                  توضیحات قابل نمایش برای مشتری
                </label>
                <textarea
                  className='form-control'
                  id='customerDescriptionTextarea'
                  rows='6'
                  defaultValue={
                    dataUpdate ? dataUpdate.customerDescription : ""
                  }
                  onChange={(e) =>
                    handelValue("customerDescription", e.target.value)
                  }
                  style={{ borderWidth: "2px" }}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row className='mt-2 mb-5'>
            <Switchrs
              label='آیا فعال باشد؟'
              name='isActiveFormOrder'
              handelValue={handelValue}
              checke={formdata.isActive}
            />
            1
            {urlPatch === "/BusinessToBusinessOnlineOrder" && (
              <Switchrs
                label=' نیاز به تایید کاربر prm دارد؟'
                name='confirmByCustomer'
                handelValue={handelValue}
                checke={formdata.confirmByCustomer}
              />
            )}
            {dataUpdate?.userId && (
              <>
                <Switchrs
                  label='آیا سفارش تکراری است؟'
                  name='isRepeatFormOrder'
                  handelValue={handelValue}
                  checke={formdata.isRepeatFormOrder}
                />

                <Switchrs
                  label='آیا پیام ویرایش برای مشتری ارسال شود؟'
                  name='isSendCustomerNotification'
                  handelValue={handelValue}
                  checke={formdata.isSendCustomerNotification}
                />

                <Switchrs
                  label='آیا پیام ویرایش برای نیرو ارسال شود؟'
                  name='isSendWorkerNotification'
                  handelValue={handelValue}
                  checke={formdata.isSendWorkerNotification}
                />
              </>
            )}
          </Form.Row>
          <Form.Row>
            <Col>
              <button
                type='submit'
                className='btn btn-success'
                onClick={handelSubmit}
                disabled={LoadingForm}
              >
                {LoadingForm ? (
                  <i className='fa fa-spinner fa-pulse fa-fw'></i>
                ) : dataUpdate?.userId ? (
                  "ثبت ویرایش"
                ) : (
                  "ثبت"
                )}
              </button>
            </Col>
            <Col>
              <Button //disabled={LoadingForm}
                disabled={
                  formdata.userId && formdata.groupId && formdata.startWork
                    ? false
                    : true
                }
                onClick={handleGetInvoice}
              >
                {LoadingForm ? (
                  <i className='fa fa-spinner fa-pulse fa-fw'></i>
                ) : invoiceData.hasOwnProperty("additionalAmount") ? (
                  "محاسبه مجدد فاکتور"
                ) : (
                  "مشاهده فاکتور"
                )}
              </Button>
            </Col>
          </Form.Row>
          <Form.Row className='mt-4'>
            {invoiceData.hasOwnProperty("additionalAmount") ? (
              <Col
                lg='6'
                md='6'
                sm='6'
                xs='6'
                className='mx-auto p-4'
                style={{ border: "1px solid gray", backgroundColor: "white" }}
              >
                <p>
                  دسته بندی: <span>{invoiceData.groupTitle}</span>
                </p>
                <p>
                  تاریخ شروع: <span>{invoiceData.persianStartWork}</span>
                </p>
                <p>
                  مقدار هزینه برای نیروی خانم:
                  <span>
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.femaleAmount)}
                  </span>
                  <small>ريال</small>
                </p>
                <p>
                  مقدار هزینه برای نیروی آقا:
                  <span>
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.maleAmount)}
                  </span>
                  <small>ريال</small>
                </p>
                <p>
                  هزینه های اضافی:
                  <span>
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.additionalAmount)}
                  </span>
                  <small>ريال</small>
                </p>
                <p>
                  هزینه خدمات اضافی:
                  <span>
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.propertyAmount)}
                  </span>
                  <small>ريال</small>
                </p>
                <p>
                  امکانات سفارش:
                  <span>
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.facilityAmounts)}
                  </span>
                  <small>ريال</small>
                </p>
                <p>
                  مقدار کل تخفیف برای نیروی خانم:
                  <span>
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.femaleDiscountAmount)}
                  </span>
                  <small>ريال</small>
                </p>
                <p>
                  مقدار کل تخفیف برای نیروی آقا:
                  <span>
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.maleDiscountAmount)}
                  </span>
                  <small>ريال</small>
                </p>
                <p>
                  مبلغ تخفیف خدمات اضافه:
                  <span>
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.propertyDiscount)}
                  </span>
                  <small>ريال</small>
                </p>
                <p>
                  کل تخفیف:
                  <span>
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.totalDiscountAmount)}
                  </span>
                  <small>ريال</small>
                </p>
                <p>
                  پورسانت پرستاری:
                  <span>
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.commissionAmount)}
                  </span>
                  <small>ريال</small>
                </p>
                <p>
                  کل هزینه:
                  <span>
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.totalAmount)}
                  </span>
                  <small>ريال</small>
                </p>
                <p>
                  مبلغ قابل پرداخت:
                  <span>
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.payableAmount)}
                  </span>
                  <small>ريال</small>
                </p>
                <p>موارد انتخاب شده:</p>
                {invoiceData.orderGroupOptions.map((item) => (
                  <p>
                    {item.title} ({item.value})
                    {new Intl.NumberFormat("ja-JP", {
                      maximumSignificantDigits: 12,
                    }).format(item.price)}
                    <small>ريال</small>
                  </p>
                ))}
              </Col>
            ) : null}
          </Form.Row>
        </Form>
      )}
      {showAddCustomer ? (
        <ModalAddCoustmer
          show={showAddCustomer}
          handleClose={handleCloseCustomer}
          setiduserCrate={setUserId}
          setUsemobileCreate={setUsemobileCreate}
        />
      ) : null}
    </>
  );
};

export default FormOrder;
